<div class="widget">
    <div [formGroup]="formGroup">
        <div>
            <button class="submitButton" mat-raised-button color="primary" (click)="submitData()" [disabled]="formGroup.invalid">Save</button>
        </div>
        <dynamic-renderer [component]="component" [data]="data" [formGroup]="formGroup"></dynamic-renderer>
    </div>
</div>
